export default __webpack_public_path__ + "static/bodySectionBg-a106825e3942a476a84c95fbf7c917d4.png";